module.exports = __webpack_public_path__ + "static/media/logo.f1b23f7b.svg";